const alerts = {
    'alert.whoops': 'Etwas ist schief gelaufen',
    'alert.whoops.message.password_mismatch': 'Die Passwörter stimmen nicht überein!',
    'alert.whoops.message.password_required': 'Das Passwortfeld ist erforderlich!',
    'alert.whoops.message.invalid_email': 'Eine gültige E-Mail-Adresse wurde nicht eingegeben. Bitte versuchen Sie es erneut',
    'alert.whoops.message.preferred_language.required': 'Die bevorzugte Sprache ist ein Pflichtfeld',
    'alert.whoops.message.company.required': 'Company is a required field',

    'alert.whoops.message.firstname.required': 'Vorname ist ein Pflichtfeld',
    'alert.whoops.message.lastname.required': 'Nachname ist ein Pflichtfeld',
    'alert.whoops.message.email.required': 'E-Mail ist ein Pflichtfeld',
    'alert.whoops.message.email.invalid': 'Die E-Mail ist ungültig',
    'alert.whoops.message.subscription.required': 'Die Auswahl eines Abonnements ist erforderlich',

    'alert.success': 'Yeah!',
    'alert.success.message.saved': 'Die Änderungen wurden erfolgreich gespeichert.',
    'alert.success.message.registered': 'Die Registrierung ist erfolgreich. Sie werden zur Anmeldeseite weitergeleitet',
    'alert.success.message.register_client': 'Registration is successful, you will receive an email to activate your account',
    'alert.success.message.synchronisation_started': 'Die Synchronisation wurde erfolgreich gestartet',

    'alert.confirm.delete': 'Möchten Sie diesen Item wirklich löschen?',
    'alert.confirm.disable': 'Möchten Sie diesen Artikel wirklich deaktivieren?',
    'alert.confirm.enable': 'Möchten Sie diesen Artikel wirklich aktivieren?',
    'alert.confirm.allow': 'Are you sure your want to allow this?',
    'alert.confirm.disallow': 'Are you sure your want to disallow this?',
    'alert.confirm.invitation.resend': 'Are you sure you want to resend the invitation?',
    'alert.confirm.start_synchronisation': 'Are you sure you want to start the synchronisation?',
    'alert.confirm.start_dryrun': 'Are you sure you want to start the dry run synchronisation?',
    'alert.confirm.active_start_synchronisation': 'Warning! the synchronisation is still going! Are you sure you want to start the synchronisation again?',
    'alert.confirm.active_start_dryrun': 'Warning! the synchronisation is still going! Are you sure you want to start the dry run synchronisation again?',
    'alert.confirm.delete.unsaved.changes': 'Möchten Sie diesen Artikel wirklich löschen? Alle nicht gespeicherten Änderungen gehen verloren.',

    'alert.title.invitation.send': 'Einladung versendet!',
    'alert.title.invitation.resend': 'Einladung nochmal verschickt!',

    'alert.combine.brands.magento': 'Magento hat keine Marken. Sie können eine Marke als Attribut kombinieren',
    'alert.combine.brands.woocommerce': 'WooCommmerce hat keine Marken. Sie können eine Marke als Attribut kombinieren',
    'alert.combine.customergroups.woocommerce': 'WooCommerce does not have customer groups, but your can configure a discount here.',
    'alert.combine.languages.woocommerce': 'WooCommerce does not have languages.',
    'alert.pricing.not.needed': 'Die Preisspanne kann nur konfiguriert werden, wenn der "Preis" nicht im Feed kombiniert wird.',

    'alert.title.succes': 'Succes!',
    'alert.confirm.client.change': 'Are you sure that you want to activate/deactivate this client?',

    'alert.subscriptions.custom_subscription_requested': 'Your request for a custom subscription is requested. You\'ll also receive a confirmation email within a few minutes.',
    'alert.subscriptions.has_custom_subscription_options': 'There are one or more custom subscriptions approved in your account. You can recognize these options by the green color. Pick the desired (custom) subscription and press "Continue to payment" to pay and activate your subscription.',
};

export default alerts;
